var map = {
	"./bundle": 2193,
	"./bundle.jsx": 2193,
	"./bundle/bundle-tenant-photo-product-presentation": 1937,
	"./bundle/bundle-tenant-photo-product-presentation.jsx": 1937,
	"./photo-sheet-product": 2194,
	"./photo-sheet-product.jsx": 2194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2511;